export default __webpack_public_path__ + "acd0230240d8e1fbd8ff56af7bd3f35a.svg";